import styled from "styled-components";

export const CardsRow = styled.div`
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	align-items: stretch;
	gap: 16px;
	width: 100%;

	@media (max-width: 1100px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	@media (max-width: 600px) {
		grid-template-columns: 1fr;
	}
`;

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	flex: 1;
	background-color: #fff;
	border: 1px solid #eeefff;
	border-radius: 8px;
	padding: 16px 20px;
	opacity: ${props => (props.loading ? 0.6 : 1)};
	transition: opacity 0.2s ease;
`;

export const CardHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 25%;
	background-color: ${props => `${props.color}1f`};
	color: ${props => props.color};
	flex-shrink: 0;
`;

export const CardLabel = styled.span`
	font-size: 14px;
	color: #6d757d;
`;

export const CardValue = styled.span`
	font-size: 32px;
	font-weight: bold;
	color: #000;
	line-height: 36px;
`;

export const BreakdownRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const BreakdownItem = styled.span`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 16px;
	color: #6d757d;

	strong {
		color: #1f2933;
	}

	&::before {
		content: "";
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: ${props => props.color};
	}
`;
